import { render } from "./Topbar.vue?vue&type=template&id=65e9ab49&ts=true"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__